import { CheckCircle2, Edit2, XCircle } from "lucide-react";

export const getUsersColumns = (handlers) => {
  const { handleEdit, handleDelete } = handlers;

  return [
    {
      key: "ClausesCategoryType",
      label: "First Name",
      render: (v) => v?.ClausesCategoryType || "-"
    },
    {
      key: "ClausesCategoryType",
      label: "Last Name",
      render: (v) => v?.ClausesCategoryType || "-"
    },
    {
      key: "ClausesCategoryType",
      label: "User Id",
      render: (v) => v?.ClausesCategoryType || "-"
    },
    {
      key: "ClausesCategoryType",
      label: "Password",
      render: (v) => v?.ClausesCategoryType || "-"
    },
    {
      key: "ClausesCategoryType",
      label: "Email",
      render: (v) => v?.ClausesCategoryType || "-"
    },
     {
      key: "ClausesCategoryType",
      label: "Role",
      render: (v) => v?.ClausesCategoryType || "-"
    },
    {
      key: "ClausesCategoryType",
      label: "Profit Center",
      render: (v) => v?.ClausesCategoryType || "-"
    },

    
    {
      key: "edit",
      label: "EDIT",
      render: (v) => (
        <div className="flex items-center gap-3">
          <button
            onClick={() => handleEdit(v)}
                className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200 "
            title="Edit"
          >
            <Edit2 size={16} />
          </button>
        </div>
      )
    },
    {
      key: "status",
      label: "STATUS",
      render: (v) => (v?.IsActive ? "Active" : "Inactive")
    },
    {
      key: "action",
      label: "ACTION",
      render: (v) => (
        <button
          // onClick={() => handleDelete(v)}
          className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-all
            ${
              v?.IsActive
                ? "bg-green-100 text-green-700 hover:bg-green-200"
                : "bg-red-100 text-red-700 hover:bg-red-200"
            }`}
          title="Toggle Status"
        >
          {v?.IsActive ? (
            <>
              <CheckCircle2 size={14} />
              Active
            </>
          ) : (
            <>
              <XCircle size={14} />
              Inactive
            </>
          )}
        </button>
      )
    }
  ];
};